// @flow
import React, { type Node, Component, Fragment } from 'react';
import ChatUIBubble from 'app/common/react/components/growth/unauth/signup/FullPageResponse/ChatUIBubble';
import i18n from 'app/common/lib/i18n';
import loginUtil from 'app/www-unauth/lib/loginUtil';
import { Box, Text, Avatar, Icon, Heading } from 'gestalt';

type Props = {|
  sender: Object,
|};

type State = {
  showIconScale: boolean,
  showFinalScene: boolean,
  shouldTranslateAvatar: boolean,
};

export default class ResponseTransitionModal extends Component<Props, State> {
  state = {
    showIconScale: false,
    showFinalScene: false,
    shouldTranslateAvatar: false,
  };

  componentDidMount() {
    window.setTimeout(this.startTransitions, 500);
  }

  startTransitions = () => {
    this.setState({ showIconScale: true });
    window.setTimeout(this.startFinalScene, 3000);
  };

  startFinalScene = () => {
    this.setState({ showFinalScene: true });
    window.setTimeout(this.changeWindow, 3000);
  };

  changeWindow = () => {
    loginUtil.handleSignupRedirect('/', true);
  };

  renderTransitionState(newUserAvatar: Node) {
    const { showIconScale, showFinalScene } = this.state;
    const { sender } = this.props;
    const firstName = sender ? sender.first_name : '';
    const image = sender ? sender.image_medium_url : '';

    const scaleGreenIcon = showIconScale
      ? {
          transform: 'scale(1.8)',
          transition: 'all .8s cubic-bezier(0.66, 0.025, 0.33, 0.975)',
        }
      : {};
    const styleOpacityMessageSentText = showIconScale
      ? {
          opacity: 1,
          transition: 'opacity .5s cubic-bezier(0.66, 0.025, 0.33, 0.975)',
        }
      : {
          opacity: 0,
        };
    const messageSentMessage = i18n._(
      'Message sent!',
      'Response letting users know the message they wrote just sent',
    );

    return (
      <Fragment>
        <Box direction="column">
          <Box
            display={showFinalScene ? 'none' : 'block'}
            position="absolute"
            width={100}
            height={100}
            dangerouslySetInlineStyle={{
              __style: {
                top: '25%',
                left: '25%',
              },
            }}
          >
            <Avatar name={firstName} src={image} />
          </Box>
          <Box
            display={showFinalScene ? 'none' : 'block'}
            position="absolute"
            dangerouslySetInlineStyle={{
              __style: {
                top: '10%',
                left: '30%',
              },
            }}
          >
            <ChatUIBubble width={200} />
          </Box>
        </Box>
        <Box direction="column">
          <Box
            position="absolute"
            width={100}
            height={100}
            dangerouslySetInlineStyle={{
              __style: {
                bottom: '26%',
                right: '19%',
              },
            }}
          >
            {newUserAvatar}
          </Box>
          <Box
            display={showFinalScene ? 'none' : 'block'}
            position="absolute"
            dangerouslySetInlineStyle={{
              __style: {
                bottom: '35%',
                right: '27%',
              },
            }}
          >
            <Box
              display={showFinalScene ? 'none' : 'block'}
              position="absolute"
              dangerouslySetInlineStyle={{
                __style: {
                  left: '42%',
                  top: '32%',
                  ...scaleGreenIcon,
                },
              }}
            >
              <Icon
                accessibilityLabel={i18n._(
                  'checkmark Green',
                  'accesibility label for a green checkmark icon',
                )}
                icon="check-circle"
                color="green"
                size={25}
              />
            </Box>
            <ChatUIBubble reverse width={200} />
          </Box>
        </Box>
        <Box
          display={showFinalScene ? 'none' : 'block'}
          position="absolute"
          dangerouslySetInlineStyle={{
            __style: {
              bottom: '13%',
              right: '32%',
            },
          }}
        >
          <div style={styleOpacityMessageSentText}>
            <Heading size="sm">{messageSentMessage}</Heading>
          </div>
        </Box>
      </Fragment>
    );
  }
  renderCompletionState(newUserAvatar: Node) {
    const { shouldTranslateAvatar } = this.state;
    window.setTimeout(() => {
      this.setState({ shouldTranslateAvatar: true });
    }, 100);
    const avatarPosition = shouldTranslateAvatar
      ? {
          bottom: '26%',
          right: '19%',
          transition: 'transform .8s cubic-bezier(0.66, 0.025, 0.33, 0.975)',
          transform: 'translate(-11em, -16em)',
        }
      : {
          bottom: '26%',
          right: '19%',
          transition: 'transform .8s cubic-bezier(0.66, 0.025, 0.33, 0.975)',
        };

    const textOpacity = shouldTranslateAvatar
      ? {
          opacity: 1,
          transition: 'opacity .5s cubic-bezier(0.66, 0.025, 0.33, 0.975)',
          transitionDelay: '.8s',
        }
      : {
          opacity: 0,
        };

    const text = (
      <Box
        position="absolute"
        dangerouslySetInlineStyle={{
          __style: {
            bottom: '24%',
            right: '23%',
            maxWidth: '52%',
          },
        }}
      >
        <Box dangerouslySetInlineStyle={{ __style: textOpacity }}>
          <Heading size="sm">
            {i18n._(
              'Now, set up your Pinterest account',
              'header asking users to set up Pinteret account after signing up',
            )}
          </Heading>
          <Box paddingY={6}>
            <Text bold size="xl" align="center">
              {i18n._(
                "This creates a home feed of ideas you'll love",
                'after signup and transition going into the nux step which will help customize their experience',
              )}
            </Text>
          </Box>
        </Box>
      </Box>
    );
    return (
      <Fragment>
        <Box
          position="absolute"
          width={100}
          height={100}
          dangerouslySetInlineStyle={{
            __style: avatarPosition,
          }}
        >
          {newUserAvatar}
        </Box>
        {text}
      </Fragment>
    );
  }
  render() {
    const { showFinalScene } = this.state;
    const newUserAvatar = (
      <Avatar
        name="unauthUser"
        src="https://i.pinimg.com/originals/d1/7f/3d/d17f3dbfdeaadfb3cddbf956f0c203d0.png"
      />
    );
    return (
      <Box marginTop={12} display="flex" flex="grow">
        {showFinalScene
          ? this.renderCompletionState(newUserAvatar)
          : this.renderTransitionState(newUserAvatar)}
      </Box>
    );
  }
}
